/**
 * 使用指南：
 * 1、srcList:传入格式
 *    1）、srcList: [
        'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
        'https://fuss10.elemecdn.com/8/27/f01c15bb73e1ef3793e64e6b7bbccjpeg.jpeg',
        'https://fuss10.elemecdn.com/1/8e/aeffeb4de74e2fde4bd74fc7b4486jpeg.jpeg'
      ],
 * 2、预览按钮文字：showTitle(例如：预览)
 * 3、示例： <image-viewer :src-list='srcList' :show-title='"查看合同1"'></image-viewer>
 */

import ElImageViewer from 'element-ui/packages/image/src/image-viewer';

export default {
  name: 'image-viewer',
  components: { ElImageViewer },
  data() {
    return {
    };
  },
  props: {
    showView: {
      type: Boolean,
      default: false
    },
    srcList: {
      type: Array,
      default: () => {return [];}
    },
    showTitle: {
      type: String,
      default: '预览'
    },
    src: {
      type: String,
      default: ''
    }
  },
  created() {
  },
  methods: {
    // 关闭查看器
    closeViewer() {
      this.$emit('closeViewer');
    }
  }
};
